import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui-kit";
import { Eraser } from "lucide-react";

const TEMPLATES = [
  ["blank", "Blank"],
  ["number_line", "Number line"],
  ["bar_model", "Bar model"],
  ["area_model", "Area model"],
  ["fraction_strip", "Fraction strip"],
];

export default function Scratchpad() {
  const canvasRef = useRef();
  const drawing = useRef(false);
  const [template, setTemplate] = useState("number_line");

  const drawTemplate = (t) => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);
    ctx.strokeStyle = "#C6CCC7";
    ctx.fillStyle = "#8B978F";
    ctx.lineWidth = 1.5;
    const W = c.width, H = c.height;
    if (t === "number_line") {
      const y = H / 2;
      ctx.beginPath(); ctx.moveTo(20, y); ctx.lineTo(W - 20, y); ctx.stroke();
      for (let i = 0; i <= 10; i++) {
        const x = 20 + (i * (W - 40)) / 10;
        ctx.beginPath(); ctx.moveTo(x, y - 8); ctx.lineTo(x, y + 8); ctx.stroke();
        ctx.fillText(String(i), x - 3, y + 22);
      }
    } else if (t === "bar_model") {
      const bw = (W - 40) / 4;
      for (let i = 0; i < 4; i++) ctx.strokeRect(20 + i * bw, H / 2 - 25, bw, 50);
    } else if (t === "area_model") {
      ctx.strokeRect(30, 20, W - 60, H - 60);
      ctx.beginPath(); ctx.moveTo(30 + (W - 60) * 0.6, 20); ctx.lineTo(30 + (W - 60) * 0.6, H - 40); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(30, 20 + (H - 60) * 0.6); ctx.lineTo(W - 30, 20 + (H - 60) * 0.6); ctx.stroke();
    } else if (t === "fraction_strip") {
      const rows = [1, 2, 3, 4];
      const rh = (H - 30) / rows.length;
      rows.forEach((n, r) => {
        const y = 15 + r * rh;
        for (let i = 0; i < n; i++) ctx.strokeRect(20 + (i * (W - 40)) / n, y, (W - 40) / n, rh - 8);
      });
    }
  };

  useEffect(() => {
    const c = canvasRef.current;
    c.width = c.offsetWidth; c.height = 220;
    drawTemplate(template);
  }, [template]);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: p.clientX - r.left, y: p.clientY - r.top };
  };
  const startDraw = (e) => { drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.beginPath(); ctx.moveTo(x, y); ctx.strokeStyle = "#1E6B52"; ctx.lineWidth = 2.5; };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const { x, y } = pos(e); ctx.lineTo(x, y); ctx.stroke(); };
  const end = () => { drawing.current = false; };

  return (
    <div className="rounded-[var(--ns-radius)] border-2 border-[var(--ns-border)] bg-white p-2" data-testid="scratchpad">
      <div className="flex items-center gap-1.5 mb-2 overflow-x-auto ns-scroll">
        {TEMPLATES.map(([id, label]) => (
          <button key={id} data-testid={`template-${id}`} onClick={() => setTemplate(id)}
            className="shrink-0 rounded-full px-3 py-1 text-xs font-semibold"
            style={{ background: template === id ? "var(--ns-primary)" : "var(--ns-surface-subtle)", color: template === id ? "#fff" : "var(--ns-muted)" }}>{label}</button>
        ))}
        <Button variant="ghost" className="!py-1 !px-2 ml-auto shrink-0" onClick={() => drawTemplate(template)}><Eraser size={14} /> Clear</Button>
      </div>
      <canvas ref={canvasRef} data-testid="scratchpad-canvas"
        className="w-full touch-none rounded-md bg-white"
        onMouseDown={startDraw} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={startDraw} onTouchMove={move} onTouchEnd={end} />
    </div>
  );
}
